import { AxiosErrorModel } from '../../../model/Axios'
import { logAxios } from '../log.axios'

export function handleRejectedAxiosRequest(error: AxiosErrorModel) {
  logAxios(error)

  return Promise.reject(error)
}
